import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Report,
  ReportTaxPermanentEmployeeReference,
  ReportTaxWithholdingAnnualPermanentEmployee,
  ReportTaxWithholdingAnnualFreelanceEmployee,
  ReportTaxPermanentEmployeeMonthly,
  ReportTaxWithholdingMonthlyRecap,
  ReportTaxWithholdingAnnualRecap,
  ReportCoretaxMonthlyWithholdingPermanentEmployees,
  ReportCoretaxFinalNonFinalWithholdingOtherThanPermanentEmployees,
  ReportCoretaxWithholdingTaxArticle26ForForeignTaxpayers,
  ReportCoretaxWithholdingTaxCertificateA1,
  ReportCoretaxWithholdingTaxCertificateA2,
  ReportPayrollSummary,
  DetailReportPayrollSummary,
  ReportPayrollSummaryPerOrganization,
  DetailReportPayrollSummaryPerOrganization,
  ReportPayrollSummaryPerComponent,
  DetailReportSummaryPerComponent,
  ReportPayroll,
  DetailReportPayroll,
  ReportBpjsEmployement,
  ReportBpjsHelathcare,
  ReportImport,
  DetailReportImport,
  ReportExport,
} from "./pages";

const reportRoutes = [
  {
    path: "/report",
    element: (
      <ProtectedRoute name="report">
        <Report />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report" defaultTitle="report.report_title" />
    ),
  },
  {
    path: "/report/permanent-employee-tax-data-reference",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportTaxPermanentEmployeeReference />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name={"report.permanent_employee_tax_data_reference"}
      />
    ),
  },
  {
    path: "/report/proof-of-withholding-annual-permanent-employee-tax",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportTaxWithholdingAnnualPermanentEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name={"report.proof_of_withholding_annual_permanent_employee_tax"}
      />
    ),
  },
  {
    path: "/report/proof-of-withholding-annual-freelance-employee-tax",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportTaxWithholdingAnnualFreelanceEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name={"report.proof_of_withholding_annual_freelance_employee_tax"}
      />
    ),
  },
  {
    path: "/report/permanent-employee-monthly-tax",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportTaxPermanentEmployeeMonthly />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"report.permanent_employee_monthly_tax"} />
    ),
  },
  {
    path: "/report/proof-of-withholding-monthly-recap",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportTaxWithholdingMonthlyRecap />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report.proof_of_withholding_monthly_recap" />
    ),
  },
  {
    path: "/report/proof-of-withholding-annual-recap",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportTaxWithholdingAnnualRecap />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report.proof_of_withholding_annual_recap" />
    ),
  },
  {
    path: "/report/coretax-proof-of-monthly-withholding-for-permanent-employees",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportCoretaxMonthlyWithholdingPermanentEmployees />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report.proof_of_monthly_withholding_for_permanent_employees" />
    ),
  },
  {
    path: "/report/coretax-proof-of-final-and-non-final-withholding-other-than-permanent-employees",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportCoretaxFinalNonFinalWithholdingOtherThanPermanentEmployees />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report.proof_of_final_and_non_final_withholding_other_than_permanent_employees" />
    ),
  },
  {
    path: "/report/proof-of-withholding-tax-article-26-for-foreign-taxpayers",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportCoretaxWithholdingTaxArticle26ForForeignTaxpayers />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report.proof_of_withholding_tax_article_26_for_foreign_taxpayers" />
    ),
  },
  {
    path: "/report/withholding-tax-certificate-a1",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportCoretaxWithholdingTaxCertificateA1 />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report.withholding_tax_certificate_a1" />
    ),
  },
  {
    path: "/report/withholding-tax-certificate-a2",
    element: (
      <ProtectedRoute name="report_tax">
        <ReportCoretaxWithholdingTaxCertificateA2 />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="report.withholding_tax_certificate_a2" />
    ),
  },
  {
    path: "/report/payroll-summary",
    element: (
      <ProtectedRoute name="report_payroll">
        <ReportPayrollSummary />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"report.payroll_summary"} />,
  },
  {
    path: "/report/payroll-summary/detail/:id",
    element: (
      <ProtectedRoute name="report_payroll">
        <DetailReportPayrollSummary />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"breadcrumb.detail"} />,
  },
  {
    path: "/report/payroll-summary-per-organization",
    element: (
      <ProtectedRoute name="report_payroll">
        <ReportPayrollSummaryPerOrganization />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"report.payroll_summary_per_organization"} />
    ),
  },
  {
    path: "/report/payroll-summary-per-organization/detail/:id",
    element: (
      <ProtectedRoute name="report_payroll">
        <DetailReportPayrollSummaryPerOrganization />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"breadcrumb.detail"} />,
  },
  {
    path: "/report/payroll-summary-per-component",
    element: (
      <ProtectedRoute name="report_payroll">
        <ReportPayrollSummaryPerComponent />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"report.payroll_summary_per_component"} />
    ),
  },
  {
    path: "/report/payroll-summary-per-component/detail/:id",
    element: (
      <ProtectedRoute name="report_payroll">
        <DetailReportSummaryPerComponent />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"breadcrumb.detail"} />,
  },
  {
    path: "/report/payroll",
    element: (
      <ProtectedRoute name="report_payroll">
        <ReportPayroll />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"reportPayroll.salary_payment"} />
    ),
  },
  {
    path: "/report/payroll/detail/:id",
    element: (
      <ProtectedRoute name="report_payroll">
        <DetailReportPayroll />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"breadcrumb.detail"} />,
  },
  {
    path: "/report/bpjs-employement",
    element: (
      <ProtectedRoute name="report_bpjs">
        <ReportBpjsEmployement />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"bpjs.bpjs_of_employement"} />
    ),
  },
  {
    path: "/report/bpjs-healthcare",
    element: (
      <ProtectedRoute name="report_bpjs">
        <ReportBpjsHelathcare />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"bpjs.bpjs_healthcare"} />,
  },
  {
    path: "/report/import",
    element: (
      <ProtectedRoute name="report_payroll">
        <ReportImport />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"reportImport.import"} />,
  },
  {
    path: "/report/import/:id",
    element: (
      <ProtectedRoute name="report_payroll">
        <DetailReportImport />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"reportImport.import_detail"} />
    ),
  },
  {
    path: "/report/export",
    element: (
      <ProtectedRoute name="report_export">
        <ReportExport />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"reportExport.export"} />,
  },
];

export default reportRoutes;
